import { capitaliseWords } from 'utils/StringHelper';

export const useDirectors = (data) => {
  const directors =
    data?.experianData?.companyDetails?.directors?.map((item) => {
      return {
        title: capitaliseWords(item.name),
        id: item.name,
      };
    }) || [];

  return { directors };
};
